import { useTranslation } from 'react-i18next'
import { SUPPORTED_LOCALES, getLocale, htmlLangOf, setLocale, type Locale } from '@/shared/i18n'
import { showToast } from '@/shared/lib'
import type { MenuGroupItem, MenuLeafItem } from '@/shared/ui/Menu'

/**
 * Выбор языка группой меню. Общий у кнопки в шапке и у меню аккаунта на узком экране.
 *
 * Подписи — самоназвания языков: «English» и «中文» читаются одинаково из любой локали, иначе
 * попавший в чужой язык не нашёл бы свой. `lang` на подписи — чтобы скринридер прочёл её
 * голосом этого языка, а браузер взял верное начертание иероглифов.
 */
export function useLocaleMenuGroup(): MenuGroupItem {
  const { t } = useTranslation()
  const current = getLocale()

  /** Словарь языка грузится при первом выборе. Не загрузился — язык прежний, тост с повтором. */
  const select = (locale: Locale) => {
    void setLocale(locale).catch(() => {
      showToast(t('locale.failed'), {
        tone: 'danger',
        action: { label: t('action.retry'), onClick: () => select(locale) },
      })
    })
  }

  return {
    kind: 'group',
    id: 'locale',
    label: t('locale.label'),
    items: SUPPORTED_LOCALES.map<MenuLeafItem>((locale) => ({
      kind: 'radio',
      id: `locale-${locale}`,
      label: <span lang={htmlLangOf(locale)}>{t(`locale.name.${locale}`)}</span>,
      textValue: t(`locale.name.${locale}`),
      checked: current === locale,
      onSelect: () => select(locale),
    })),
  }
}
